import React from "react";
import PropTypes from "prop-types";
import Rate from "rc-rate";
import FontAwesome from "react-fontawesome";
import "rc-rate/assets/index.css";
import { FormControl, ButtonGroup, Button } from "react-bootstrap";

const RatingsQuestion = ({
  ratingType,
  questionNumber,
  questionPrompt,
  state,
  handleStarClick,
  handleCommentInput,
  postRateCandidatesLoading,
}) => {
  const onStarClick = (nextValue) => {
    handleStarClick(questionNumber, nextValue);
  };
  const onTenStarClick = (e) => {
    const nextValue = Number(e.target.value);
    handleStarClick(questionNumber, nextValue);
  };
  const onThumbClick = (e) => {
    const nextValue = e.target.dataset.value;
    handleStarClick(questionNumber, nextValue);
  };
  const onCommentInput = (event) => {
    handleCommentInput(questionNumber, event.target.value);
  };
  const RatingTypeDisplay = (() => {
    if (ratingType === "stars") {
      return (
        <Rate
          className="rate_modal"
          count={5}
          value={state.value}
          style={{ fontSize: 20 }}
          onChange={onStarClick}
          character={<FontAwesome name="star" size="lg" />}
        />
      );
    }
    if (ratingType === "thumbs") {
      return (
        <div>
          {state.value > 0 || state.value === null ? (
            <FontAwesome
              name="thumbs-down"
              style={{ fontSize: 20, color: "lightGrey" }}
              onClick={onThumbClick}
              data-value={0}
            />
          ) : (
            <FontAwesome
              name="thumbs-down"
              style={{ fontSize: 20 }}
              onClick={onThumbClick}
              data-value={0}
            />
          )}
          {state.value > 0 && state.value !== null ? (
            <FontAwesome
              name="thumbs-up"
              style={{ fontSize: 20, marginLeft: "10px" }}
              onClick={onThumbClick}
              data-value={1}
            />
          ) : (
            <FontAwesome
              name="thumbs-up"
              style={{ fontSize: 20, color: "lightGrey", marginLeft: "10px" }}
              onClick={onThumbClick}
              data-value={1}
            />
          )}
        </div>
      );
    }
    const Items = [];
    for (let number = 1; number <= 10; number += 1) {
      Items.push(
        <Button
          variant={number === state.value ? "primary" : "default"}
          active={number === state.value}
          value={number}
          onClick={onTenStarClick}
          key={`tenStarNum${number}`}
          id={`rateTen_${number}`}
        >
          {number}
        </Button>
      );
    }
    return (
      <ButtonGroup style={{ marginBottom: "7px" }} size="small">
        {Items}
      </ButtonGroup>
    );
  })();

  return (
    <div className="mt-3">
      <h6>{questionPrompt}</h6>
      <div className="mb-3">{RatingTypeDisplay}</div>
      <FormControl
        as="textarea"
        placeholder="add a comment.."
        value={state.comment || ""}
        onChange={onCommentInput}
        rows="2"
        disabled={postRateCandidatesLoading}
      />
    </div>
  );
};

RatingsQuestion.propTypes = {
  ratingType: PropTypes.string,
  questionNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  questionPrompt: PropTypes.string,
  state: PropTypes.object,
  handleStarClick: PropTypes.func,
  handleCommentInput: PropTypes.func,
  postRateCandidatesLoading: PropTypes.bool,
};

export default RatingsQuestion;
